module.exports = __webpack_public_path__ + "static/media/stripe_icon.1b944dcf.svg";